import { SHA256 } from 'crypto-js';
import { generateUniqEventId } from 'src/shared/utils/generateUniqEventId';

declare global {
  interface Window {
    ttq: any;
  }
}

export class TikTokService {
  id = 'tiktok';

  isDebugOnly = false;

  private token: string;

  constructor(token: string, isDebugOnly: boolean) {
    this.token = token;
    this.isDebugOnly = isDebugOnly;
  }

  public initialize() {
    try {
      if (!this.token) {
        throw new Error('Token is missing');
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
          ttq.load('${this.token}');
          ttq.page();
        }(window, document, 'ttq');
      `;
      document.head.appendChild(script);
      console.log('[TikTokService]: Initialized 🚀');
    } catch (e) {
      console.error(`[TikTokService]: Initialization failed:`, e);
    }
  }

  public sendEvent(eventName: string, properties?: Record<string, any>) {
    try {
      const { eventInstanceId, userId, email, firstName, lastName, ...restProperties } = properties ?? {};
      let uniqEventId = null;
      if (userId && eventInstanceId) {
        uniqEventId = generateUniqEventId(eventName, userId, eventInstanceId);
      }

      window?.ttq?.track?.(eventName, restProperties, uniqEventId ? { event_id: uniqEventId } : {});

      console.log(`[TikTokService]: Track event: ${eventName} completed`);
    } catch (e) {
      console.error(`[TikTokService]: Track event ${eventName} error: `, e);
    }
  }

  public identify(userId: string, properties?: Record<string, any>) {
    try {
      window?.ttq?.identify?.({
        ...(userId && { external_id: SHA256(userId).toString() }),
        ...(properties?.$email && { email: SHA256(properties.$email).toString() }),
      });

      console.log(`[TikTokService]: Identify user completed`);
    } catch (e) {
      console.error(`[TikTokService]: Identify user error: `, e);
    }
  }
}
